import { render } from "./QuoteSummary.vue?vue&type=template&id=88621fa0&scoped=true&lang=pug"
import script from "./QuoteSummary.vue?vue&type=script&lang=js"
export * from "./QuoteSummary.vue?vue&type=script&lang=js"

import "./QuoteSummary.vue?vue&type=style&index=0&id=88621fa0&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88621fa0"]])

export default __exports__